module.exports = __webpack_public_path__ + "static/img/a9.520e463d.png";